var map = {
	"./ad.svg": "1490",
	"./ae.svg": "3eef",
	"./af.svg": "4259",
	"./ag.svg": "39dc",
	"./al.svg": "9887",
	"./alarm.svg": "9dbe",
	"./alert.svg": "a536",
	"./allergens/celery.svg": "1c5c",
	"./allergens/crustaceans.svg": "d940",
	"./allergens/eggs.svg": "2e6d",
	"./allergens/fish.svg": "3ee2",
	"./allergens/gluten.svg": "cdd0",
	"./allergens/lupin.svg": "cd8f",
	"./allergens/milk.svg": "9095",
	"./allergens/molluscs.svg": "aefb",
	"./allergens/mustard.svg": "d4cb",
	"./allergens/peanuts.svg": "e759",
	"./allergens/sesame.svg": "c6d9",
	"./allergens/soy.svg": "03e1",
	"./allergens/sulfites.svg": "4069",
	"./allergens/tree-nuts.svg": "8486",
	"./am.svg": "d121",
	"./ao.svg": "b3f5",
	"./apple-pay.svg": "8df7",
	"./apply-all.svg": "8598",
	"./ar.svg": "779b",
	"./arrow-down-2.svg": "6272",
	"./arrow-down.svg": "5c02",
	"./arrow-left.svg": "655c",
	"./arrow-right.svg": "4df3",
	"./arrow-up.svg": "bb84",
	"./at.svg": "576d",
	"./au.svg": "7135",
	"./aw.svg": "2829",
	"./az.svg": "31de",
	"./ba.svg": "4204",
	"./back-arrow.svg": "6d1b",
	"./bb.svg": "68cd",
	"./bd.svg": "fa37",
	"./be.svg": "c957",
	"./bell-slash.svg": "090f",
	"./bell.svg": "4d93",
	"./bf.svg": "627c",
	"./bg.svg": "bd6c",
	"./bh.svg": "2d91",
	"./bi.svg": "1e0a",
	"./bike.svg": "b1af",
	"./bizum.svg": "afad",
	"./bj.svg": "92e6",
	"./bn.svg": "3601",
	"./bo.svg": "9117",
	"./br.svg": "6cb7",
	"./brands.svg": "45d8",
	"./bs.svg": "122a",
	"./bt.svg": "f3c2",
	"./burger.svg": "06bb",
	"./bv.svg": "d5bd",
	"./bw.svg": "5d91",
	"./by.svg": "69de",
	"./bz.svg": "fc72",
	"./ca.svg": "f689",
	"./calculator.svg": "70bd",
	"./calendar-red.svg": "9138",
	"./calendar.svg": "2618",
	"./card.svg": "b9df",
	"./cart.svg": "c77c",
	"./cash.svg": "ebea",
	"./cat.svg": "6f6c",
	"./catalog.svg": "4755",
	"./cf.svg": "fbe8",
	"./cg.svg": "ce62",
	"./ch.svg": "bac5",
	"./chain.svg": "c02a",
	"./chat.svg": "7e29",
	"./check-circle.svg": "29de",
	"./check.svg": "c3c1",
	"./cl.svg": "7fcf",
	"./clean.svg": "5cb0",
	"./clock.svg": "0ff1",
	"./close-store.svg": "219e",
	"./close.svg": "9eea",
	"./cm.svg": "6019",
	"./cn.svg": "3110",
	"./co.svg": "09ac",
	"./contract.svg": "c8b4",
	"./copies.svg": "276d",
	"./cr.svg": "7f91",
	"./cross-eye.svg": "3309",
	"./cu.svg": "77b4",
	"./currencies/dollar.svg": "1cea",
	"./currencies/euro.svg": "7a8b",
	"./cy.svg": "2307",
	"./cz.svg": "6d47",
	"./danger.svg": "9522",
	"./de.svg": "049c",
	"./default-notification.svg": "6b3c",
	"./delete-arrow.svg": "8202",
	"./delivery.svg": "3195",
	"./device.svg": "18dc",
	"./diners.svg": "940d",
	"./discount.svg": "b3f3",
	"./dj.svg": "e119",
	"./dk.svg": "4343",
	"./dm.svg": "64e1",
	"./do.svg": "d1be",
	"./done.svg": "fd0a",
	"./dots.svg": "7e13",
	"./drag.svg": "0570",
	"./dropdown-menu.svg": "7f5b",
	"./duplicate.svg": "e262",
	"./dz.svg": "01e2",
	"./ec.svg": "2993",
	"./ee.svg": "884b",
	"./eg.svg": "1d2b4",
	"./empanadish.svg": "cf00",
	"./empty.svg": "035b",
	"./en.svg": "ddac",
	"./end-shift.svg": "a9b1",
	"./er.svg": "815e",
	"./error.svg": "4cb7",
	"./es.svg": "079b",
	"./et.svg": "6cc6",
	"./euro.svg": "92b6",
	"./expand.svg": "89c3",
	"./external.svg": "c450",
	"./eye-closed.svg": "d4ee",
	"./eye-disabled.svg": "a38f",
	"./eye.svg": "14c7",
	"./fi.svg": "bdd4",
	"./file.svg": "126f",
	"./filters.svg": "1591",
	"./fj.svg": "5b91",
	"./flag.svg": "7c4d",
	"./floorplan.svg": "8fb0",
	"./forward.svg": "0901",
	"./fr.svg": "7cb8",
	"./ga.svg": "ce9d",
	"./gb.svg": "e559",
	"./gd.svg": "f9f2",
	"./ge.svg": "e477",
	"./gh.svg": "c334",
	"./gm.svg": "e9ea",
	"./gn.svg": "97fc",
	"./google-pay.svg": "ac6f",
	"./gq.svg": "89d1",
	"./gr.svg": "7baa",
	"./gt.svg": "8756",
	"./gw.svg": "3f83",
	"./gy.svg": "f38c",
	"./handle.svg": "811c",
	"./help.svg": "bfb4",
	"./history.svg": "1f49",
	"./hk.svg": "7a7f",
	"./hn.svg": "c4ce",
	"./home.svg": "2f4f",
	"./hr.svg": "6d5c",
	"./ht.svg": "d837",
	"./hu.svg": "dbb8",
	"./id.svg": "89c1",
	"./idle-clock.svg": "65aa",
	"./ie.svg": "d95e",
	"./il.svg": "1c7f",
	"./important-round.svg": "ce1a",
	"./in-out.svg": "7698",
	"./in.svg": "6874",
	"./info.svg": "21bc",
	"./integration.svg": "3f7e",
	"./iq.svg": "5ff2",
	"./is.svg": "a3b7",
	"./it.svg": "7736",
	"./izettle.svg": "63ff",
	"./jm.svg": "c43f",
	"./jo.svg": "ea50",
	"./jp.svg": "7b97",
	"./ke.svg": "1262",
	"./kg.svg": "7646",
	"./kh.svg": "1034",
	"./ki.svg": "53f8",
	"./kitchen.svg": "47e6",
	"./km.svg": "5f7f",
	"./kp.svg": "fed7",
	"./kr.svg": "7c69",
	"./kw.svg": "cc50",
	"./kz.svg": "8134",
	"./lb.svg": "a599",
	"./lc.svg": "5e26",
	"./li.svg": "cc19",
	"./line-menu.svg": "a853",
	"./list.svg": "2ddb",
	"./lk.svg": "932b",
	"./loading-error.svg": "a424",
	"./loading-spinner.svg": "bf3f",
	"./loading.svg": "f73a",
	"./location.svg": "d89d",
	"./lock.svg": "0e7d",
	"./login-logo.svg": "4e3c",
	"./logo.svg": "386e",
	"./lr.svg": "753b",
	"./ls.svg": "6b09",
	"./lt.svg": "0d90",
	"./lu.svg": "8676",
	"./lv.svg": "d36c",
	"./ly.svg": "9e05",
	"./ma.svg": "a686",
	"./mail.svg": "47cf",
	"./man.svg": "8cce",
	"./map.svg": "3917",
	"./mc.svg": "6472",
	"./md.svg": "512e",
	"./me.svg": "2843",
	"./menu-hamburguer.svg": "de54",
	"./merge.svg": "979a",
	"./mg.svg": "c0ec",
	"./mh.svg": "d2f6",
	"./minus.svg": "43a0",
	"./mk.svg": "d919",
	"./ml.svg": "a579",
	"./mm.svg": "dcfc",
	"./mn.svg": "3010",
	"./mr.svg": "3385",
	"./mt.svg": "6ff3",
	"./mu.svg": "7236",
	"./mute.svg": "7547",
	"./mv.svg": "67cb",
	"./mw.svg": "d755",
	"./mx.svg": "37ac",
	"./my.svg": "18fe",
	"./mz.svg": "ca7c",
	"./na.svg": "5cdf",
	"./ne.svg": "ab69",
	"./new.svg": "2d84",
	"./ng.svg": "bd4e",
	"./ni.svg": "aa49",
	"./nl.svg": "f468",
	"./no.svg": "8422",
	"./nobookings.svg": "c758",
	"./np.svg": "adc4",
	"./nr.svg": "102e",
	"./nz.svg": "a883",
	"./om.svg": "7868",
	"./order.svg": "8fec",
	"./organization.svg": "0fab",
	"./pa.svg": "611e",
	"./paint.svg": "35d3",
	"./payment-ticket.svg": "82c3",
	"./pe.svg": "5095",
	"./pen.svg": "8fe8",
	"./pending-payment.svg": "27fb",
	"./people.svg": "5615",
	"./percentage.svg": "4ff5",
	"./pg.svg": "9166",
	"./ph.svg": "54d5",
	"./phone.svg": "2542",
	"./pk.svg": "138a",
	"./pl.svg": "e6ee",
	"./plus.svg": "2234",
	"./porcentaje.svg": "561e",
	"./printer.svg": "c4d3",
	"./product-specs/glutenfree.svg": "c74a",
	"./product-specs/hot.svg": "b6b2",
	"./product-specs/medium.svg": "c3bf",
	"./product-specs/mild.svg": "232e",
	"./product-specs/vegan.svg": "ab4f",
	"./product-specs/vegetarian.svg": "c555",
	"./product.svg": "a9a2",
	"./products-icon.svg": "6236",
	"./pt.svg": "79b6",
	"./pw.svg": "71be",
	"./py.svg": "39ad",
	"./qa.svg": "c2cc",
	"./qr.svg": "bdc4",
	"./question.svg": "ab21",
	"./reports.svg": "8666",
	"./reuse.svg": "7310",
	"./ro.svg": "2e53",
	"./rotar.svg": "3d72",
	"./rs.svg": "8f08",
	"./ru.svg": "113c",
	"./rw.svg": "bf90",
	"./sa.svg": "4182",
	"./sb.svg": "cd21",
	"./sc.svg": "49fb",
	"./sd.svg": "ce20",
	"./se.svg": "b58f",
	"./search.svg": "8177",
	"./select-all.svg": "1e91",
	"./settings.svg": "28a9",
	"./sg.svg": "2e7f",
	"./shop.svg": "cba1",
	"./si.svg": "ce8a",
	"./sk.svg": "67f3",
	"./sl.svg": "a151",
	"./sm.svg": "f1e6",
	"./small-arrow-right.svg": "7fb0",
	"./sn.svg": "f06a",
	"./so.svg": "b480",
	"./square-menu.svg": "c6fb",
	"./sr.svg": "78f5",
	"./ss.svg": "7778",
	"./st.svg": "d2aa",
	"./store.svg": "74b2",
	"./sunday-logo.svg": "f85a",
	"./super-tip.svg": "080d",
	"./support.svg": "a7f9",
	"./sv.svg": "38c5",
	"./sy.svg": "8ddd",
	"./sz.svg": "e787",
	"./tabs.svg": "72dfa",
	"./take-away-small.svg": "14a0",
	"./take-away.svg": "93e8",
	"./td.svg": "5cd4",
	"./tg.svg": "b114",
	"./th.svg": "8293",
	"./ticket.svg": "28a4",
	"./till.svg": "68da",
	"./time.svg": "3a2d",
	"./tip.svg": "7bf1",
	"./tj.svg": "ced8",
	"./tl.svg": "48ea",
	"./tm.svg": "0f28",
	"./tn.svg": "6f23",
	"./to.svg": "ba64",
	"./tr.svg": "b0ce",
	"./trash.svg": "1380",
	"./tt.svg": "9bee",
	"./turn-off.svg": "a37a",
	"./tv.svg": "1342",
	"./tz.svg": "d8ac",
	"./ua.svg": "9f0d",
	"./ug.svg": "fe2b",
	"./upload.svg": "0a78",
	"./us.svg": "263d",
	"./user.svg": "980a",
	"./uy.svg": "79e7",
	"./uz.svg": "4503",
	"./validate.svg": "2dbb",
	"./ve.svg": "5431",
	"./vn.svg": "1fd0",
	"./ws.svg": "c4f2",
	"./ye.svg": "74ef",
	"./za.svg": "2b6b",
	"./zm.svg": "c45d",
	"./zoom.svg": "3b88",
	"./zw.svg": "9cae"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f304";